import makeEntityServiceCalls from 'redux-core/serviceHelpers';

export const {
  getAll: getAllCues,
  update: updateCueCall,
  get: getCueByIdCall,
} = makeEntityServiceCalls('cues', 'clear');
